import React from 'react'
import Translation from '../global/Translation'

import { connect } from 'react-redux'
import { toggleSegmentation, selectKB } from '../../store/segmentation/actions'
import { getKBOptions, getSelectedKB, getCurrentSegmentation } from '../../store/segmentation/reducers'

const mapStateToProps = state => {
    return {
        show: getCurrentSegmentation(state) === 'KB',
        selected: getSelectedKB(state),
        options: getKBOptions(state)
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onToggle: () => {
            dispatch(toggleSegmentation('KB'))
        },
        onSelect: value => {
            dispatch(selectKB(value))
        }
    }
}
const KB = ({ show, selected, onToggle, onSelect, options }) => {
    if (!options || options.length === 0) {
        return ''
    }
    const selectedValue = selected ? <span>{selected.name}</span> : null
    return (
        <div>
            <div onClick={onToggle} className="option">
                <Translation id="kb" defaultMessage="KB" /> : {selectedValue}
                <i className={show ? 'fa fa-caret-down' : 'fa fa-caret-right'} aria-hidden="true" />
                <br />
            </div>

            <div style={{ display: show ? 'block' : 'none' }}>
                <div className="row segment-selections">
                    {options.map(option => (
                        <span
                            key={option.id}
                            onClick={() => {
                                onSelect(option)
                            }}
                        >
                            {option.name}
                        </span>
                    ))}
                </div>
            </div>
            <hr />
        </div>
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(KB)
